export var AttributionBenchmarkOption;
(function (AttributionBenchmarkOption) {
    AttributionBenchmarkOption["ASSIGNED"] = "assigned";
    AttributionBenchmarkOption["S_AND_P"] = "s_and_p";
    AttributionBenchmarkOption["CUSTOM"] = "custom";
})(AttributionBenchmarkOption || (AttributionBenchmarkOption = {}));
export var AttributionCategorization;
(function (AttributionCategorization) {
    AttributionCategorization["SECTOR"] = "sector";
    AttributionCategorization["EQUITY_STYLE"] = "equity_style";
    AttributionCategorization["BOND_SECTOR"] = "bond_sector";
    AttributionCategorization["BOND_MATURITY"] = "bond_maturity";
    AttributionCategorization["BROAD_ASSET_CLASS"] = "broad_asset_class";
})(AttributionCategorization || (AttributionCategorization = {}));
export var PerformancePeriodicity;
(function (PerformancePeriodicity) {
    PerformancePeriodicity["ONE_DAY"] = "1d";
    PerformancePeriodicity["FIVE_DAYS"] = "5d";
    PerformancePeriodicity["ONE_MONTH"] = "1m";
    PerformancePeriodicity["THREE_MONTHS"] = "3m";
    PerformancePeriodicity["SIX_MONTHS"] = "6m";
    PerformancePeriodicity["YTD"] = "ytd";
    PerformancePeriodicity["ONE_YEAR"] = "1y";
    PerformancePeriodicity["FIVE_YEARS"] = "5y";
    PerformancePeriodicity["TEN_YEARS"] = "10y";
    PerformancePeriodicity["TWENTY_YEARS"] = "20y";
    PerformancePeriodicity["MAX"] = "max";
})(PerformancePeriodicity || (PerformancePeriodicity = {}));
